<template>
  <v-layout align-start>
    <v-flex>
      <div id="app">
        <v-app id="inspire">
          <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="12">
              <v-card ref="form">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" class="py-0 mt-0">
                      <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date" label="Fecha de la Liquidacion" prepend-icon="event" readonly
                            v-bind="attrs" v-on="on" outlined @click="turnos()"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" @input="menu2 = false"
                          v-on:change="selectturnofecha()"></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 mt-0">
                      <v-select v-model="turnoid" :items="turnoselect" label="Turno No." outlined
                        v-on:change="selectturno()"></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" class="mt-n8 mx-auto">
                      <v-select v-model="liquidaid" :items="liquidaselect" label="Isla: Nombre del Despachador" outlined
                        v-on:change="despachador()"></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" class="mt-n12 mx-auto">
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col cols="12" class="text-center">
                            <v-btn color="primary" @click="iniciarReconocimiento">
                              🎤 Hablar
                            </v-btn>
                            <p v-if="transcript" class="mt-4">
                              Texto reconocido: <strong>{{ textoSinEspacios }}</strong>
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-col>




                  </v-row>

                  <div class="text-center mt-n8 mx-auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="totaldepachador" v-on="on">
                          <v-icon dark>
                            paid
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Liquidacion por Despachador</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="totalservisioturno" v-on="on">
                          <v-icon dark>
                            point_of_sale
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Liquidacion por Turno</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="recibos" v-on="on">
                          <v-icon dark>
                            history_edu
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Recibos</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark large color="primary" @click="reclasificacion" v-on="on">
                          <v-icon dark>
                            savings
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Reclasificacion de Tickets</span>
                    </v-tooltip>
                  </div>
                </v-container>

                <v-dialog v-model="modalservicio" max-width="1100">
                  <v-card>
                    <v-col cols="12" md="12">
                      <b-card no-body>
                        <b-tabs card>
                          <b-tab title="Captura">
                            <v-expansion-panels v-model="panel" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  {{ servicionombre }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-alert shaped dark color="primary">
                                    {{ servicionombre }}
                                  </v-alert>

                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="8" md="8" class="mt-n8 mx-auto">
                                          <v-text-field v-model="despachadornombre" label="Nombre del Despachador"
                                            filled readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" class=" mt-n8 mx-auto">
                                          <vuetify-money v-model="bancariaacumulado" label="Total" readonly filled
                                            outlined v-bind:options="options" />
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class=" mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-autocomplete v-model="clienteigas" label="Buscar Cliente"
                                            :items="clientestodosselect" item-text="clientenombre"
                                            item-value="clienteigas" @keydown.tab="clientebusca()"
                                            v-on:blur="clientebusca()" outlined></v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-autocomplete v-model="creditounidad" label="Buscar Unidad"
                                            :items="vehiculostodosselect" item-text="vehiculonombre"
                                            item-value="vehiculonombre" @keydown.tab="vehiculobusca()"
                                            v-on:blur="vehiculobusca()" outlined></v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" v-if="servicioid == 3" class="mt-n10 mx-auto">
                                          <v-select v-model="combustibleid" :items="combustibleselect"
                                            label="Tipo de Combustible" outlined></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class=" mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-text-field v-model="credito" label="Vale" outlined ref="fococredito"
                                            @keydown.tab="valeoticket()" v-on:blur="valeoticket()"
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class=" mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                            type="number" ref="focoimportecredito"
                                            @keydown.space="guardar()"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class=" mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-text-field v-model="creditoticket" label="Ticket" outlined
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" v-if="servicioid == 3" class="mt-n10 mx-auto">
                                          <v-select v-model="creditovale" :items="creditovaleselect"
                                            label="Tipo Credito" outlined></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" v-if="servicioid == 3" class="mt-n10 mx-auto">
                                          <v-select v-model="departamentoid" :items="departamentoselect"
                                            label="Departamento" outlined></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" class=" mt-n10 mx-auto" v-if="servicioid == 3">
                                          <v-text-field v-model="creditoautorizaocarga" label="Autorizo"
                                            outlined></v-text-field>
                                        </v-col>

                                        <div class="text-center mt-n8 mx-auto">
                                          <v-btn color="primary" @click="limpiarcredito" v-if="servicioid == 3">
                                            <v-icon dark>
                                              clean_hands
                                            </v-icon>
                                          </v-btn>

                                        </div>


                                        <v-col cols="12" sm="8" md="8" v-if="servicioid == 1" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                            type="number" ref="focoimporte" @keydown.space="guardar()"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" v-if="servicioid == 1" class="mt-n10 mx-auto">
                                          <v-select v-model="restobilleteefectivo" :items="restobilleteefectivoselect"
                                            label="Efectivo" outlined v-on:change="formadeabono()"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" v-if="servicioid == 6" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientodolares" label="Numero de Dolares" outlined
                                            type="number" @keydown.tab="totaldolares()"
                                            v-on:blur="totaldolares()"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" v-if="servicioid == 6" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientovalordolares" label="Costo de Dolares"
                                            outlined type="number" readonly></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" v-if="servicioid == 6" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                            type="number" @keydown.tab="totaldolares()"
                                            v-on:blur="totaldolares()"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" v-if="servicioid == 14" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" v-if="servicioid == 14" class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientodolares" label="Litros" outlined
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" v-if="
                                          servicioid != 3 &&
                                          servicioid != 1 &&
                                          servicioid != 6 &&
                                          servicioid != 14
                                        " class="mt-n10 mx-auto">
                                          <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                            type="number" ref="focoimporte" @keydown.space="guardar()"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" class="mt-n0 mx-auto">
                                          <v-textarea outlined name="input-7-4" label="Observacion"
                                            v-model="movimientoobservacion"></v-textarea>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions class="mt-n10 mx-auto">
                                    <div class="flex-grow-1 "></div>
                                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar"
                                      v-if="verguardarservicio">Guardar</v-btn>
                                  </v-card-actions>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>
                          <b-tab title="Movimientos">
                            <v-expansion-panels v-model="panel" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  {{ servicionombre }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>



                                  <v-list subheader two-line class="pa-0 ma-0">

                                    <template v-for="(item, index) in movimientoselect">


                                      <v-list-item class="m-n4">
                                        <v-list-item-content>
                                          <v-list-item-title v-text="formatPrice(item.movimientoimporte)
                                            ">
                                          </v-list-item-title>
                                          <v-list-item-subtitle
                                            v-text="item.movimientoobservacion"></v-list-item-subtitle>

                                          <v-list-item-subtitle v-text="item.movimientohora"></v-list-item-subtitle>

                                          <v-list-item-subtitle v-if="item.servicioid == 3"
                                            v-text="item.combustiblenombre"></v-list-item-subtitle>
                                          <v-list-item-subtitle v-if="item.servicioid == 3"
                                            v-text="item.creditolitros"></v-list-item-subtitle>

                                        </v-list-item-content>

                                        <v-list-item-action>
                                          <v-btn icon>
                                            <v-icon @click="eliminarmovimiento(item)">delete</v-icon>
                                          </v-btn>
                                        </v-list-item-action>

                                        <v-list-item-action>
                                          <v-btn icon>
                                            <v-icon @click="editarservicio(item)">edit</v-icon>
                                          </v-btn>
                                        </v-list-item-action>

                                        <v-list-item-action>
                                          <v-btn icon>
                                            <v-icon @click="imprimeservicio(item)">print</v-icon>
                                          </v-btn>
                                        </v-list-item-action>

                                        <v-list-item-action v-if="item.restobilleteefectivo == 2">
                                          <v-btn icon>
                                            <v-icon @click="capturabilleresresto(item)">local_atm</v-icon>
                                          </v-btn>
                                        </v-list-item-action>

                                        <v-list-item-action v-if="
                                          item.servicioid == 3 &&
                                          item.creditovale == 2
                                        ">
                                          <v-btn icon>
                                            <v-icon @click="capturacreditodetalle(item)">price_change</v-icon>
                                          </v-btn>
                                        </v-list-item-action>
                                      </v-list-item>

                                      <v-divider v-if="index < movimientoselect.length - 1" :key="index"></v-divider>
                                    </template>

                                  </v-list>









                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>
                        </b-tabs>
                      </b-card>
                    </v-col>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modaltotaldespachador" max-width="800">
                  <v-card>
                    <v-alert shaped dark color="primary">
                      Total Despachador
                    </v-alert>
                    <v-card-title>
                      <span class="headline">{{ servicionombre }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="despachadornombre" label="Nombre del Despachador" filled
                              readonly></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoefectivo" label="Total Efectivo" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientoefectivo" />
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoefectivomasdolares" label="Total Efectivo mas Dolares"
                              readonly filled outlined v-bind:options="options" v-if="islamovimientoefectivo" />
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientobancaria" label="Total Bancarias" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientobancaria" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">


                            <v-btn-toggle v-if="islamovimientobancaria">
                              <v-btn @click="pdfservisioisla(2)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientocredito" label="Total Credito" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientocredito" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoacord" label="Total Acord" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientoacord" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoefecticard" label="Total Efecticard" readonly filled
                              outlined v-bind:options="options" v-if="islamovimientoefecticard" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientodolares" label="Total Dolares" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientodolares" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientocupones" label="Total Cupones" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientocupones" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientocheque" label="Total Cheques" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientocheque" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientotransferencia" label="Total Transferencias" readonly
                              filled outlined v-bind:options="options" v-if="islamovimientotransferencia" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientosodexo" label="Total Sodexo" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientosodexo" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoultragas" label="Total UltraGas" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientoultragas" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoaceites" label="Total Aceites" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientoaceites" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoaceitescredito" label="Total Aceites Credito" readonly
                              filled outlined v-bind:options="options" v-if="islamovimientoaceitescredito" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientobienestar" label="Total Bienestar" readonly filled
                              outlined v-bind:options="options" v-if="islamovimientobienestar" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientotienda" label="Total Tienda" readonly filled outlined
                              v-bind:options="options" v-if="islamovimientotienda" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientototalisla" label="Total Isla" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="mt-n10 mx-auto">
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modaltotalturno" max-width="800">
                  <v-card>
                    <v-alert shaped dark color="primary">
                      Total Turno
                    </v-alert>


                    <div class="text-center mt-n2 mx-auto">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn class="mx-2" fab dark large color="primary" @click="imprimevarios()" v-on="on">
                            <v-icon dark>
                              attach_money
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Total Varios</span>
                      </v-tooltip>
                    </div>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-input label="Todas Las Islas" filled readonly></v-input>
                          </v-col>
                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoefectivoturno" label="Total Efectivo" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientoefectivoturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">

                            <v-btn-toggle v-if="totalmovimientoefectivoturno">
                              <v-btn @click="pdfservisioturno(1)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientobancariaturno" label="Total Bancarias" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientobancariaturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">


                            <v-btn-toggle v-if="totalmovimientobancariaturno">
                              <v-btn @click="pdfservisioturno(2)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12" sm="5" md="4" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientocreditoturno" label="Total Credito" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientocreditoturno" />
                          </v-col>

                          <v-col cols="8" sm="5" md="5" class="mt-n10 mx-auto">
                            <v-select v-model="listarclienteid" :items="listarclienteselect" label="Clientes" outlined
                              v-if="totalmovimientocreditoturno"></v-select>
                          </v-col>

                          <v-col cols="4" sm="2" md="3" class="mt-n10 mx-auto" v-if="totalmovimientocreditoturno">

                            <v-menu offset-y>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn class="white--text ma-5" v-bind="attrs" v-on="on" color='teal darken-1'>
                                  <v-icon>picture_as_pdf</v-icon>
                                </v-btn>
                              </template>

                              <v-list>
                                <v-list-item link>
                                  <v-list-item-title @click="pdfrelacioncredito()">
                                    <v-icon>print</v-icon></v-list-item-title>
                                </v-list-item>
                                <v-list-item link>
                                  <v-list-item-title @click="pdfservisioturno(3)">
                                    <v-icon>contact_page</v-icon></v-list-item-title>
                                </v-list-item>
                                <v-list-item link>
                                  <v-list-item-title @click="pdfcreditoisla()">
                                    <v-icon>request_page</v-icon></v-list-item-title>
                                </v-list-item>



                              </v-list>
                            </v-menu>

                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoacordturno" label="Total Acord" readonly filled outlined
                              v-bind:options="options" v-if="totalmovimientoacordturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientoacordturno">
                              <v-btn @click="pdfservisioturno(4)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoefecticardturno" label="Total Efecticard" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientoefecticardturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientoefecticardturno">
                              <v-btn @click="pdfservisioturno(5)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientodolaresturno" label="Total Dolares" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientodolaresturno" />
                          </v-col>
                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientodolaresturno">
                              <v-btn @click="pdfservisioturno(6)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientocuponesturno" label="Total Cupones" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientocuponesturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientocuponesturno">
                              <v-btn @click="pdfservisioturno(7)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientochequeturno" label="Total Cheques" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientochequeturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientochequeturno">
                              <v-btn @click="pdfservisioturno(8)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientotransferenciaturno" label="Total Transferencias" readonly
                              filled outlined v-bind:options="options" v-if="totalmovimientotransferenciaturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">

                            <v-btn-toggle v-if="totalmovimientotransferenciaturno">
                              <v-btn @click="pdfservisioturno(9)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientosodexoturno" label="Total Sodexo" readonly filled outlined
                              v-bind:options="options" v-if="totalmovimientosodexoturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientosodexoturno">
                              <v-btn @click="pdfservisioturno(10)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoultragasturno" label="Total UltraGas" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientoultragasturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientoultragasturno">
                              <v-btn @click="pdfservisioturno(11)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoaceitesturno" label="Total Aceites" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientoaceitesturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientoaceitesturno">
                              <v-btn @click="pdfservisioturno(12)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientoaceitescreditoturno" label="Total Aceites Credito"
                              readonly filled outlined v-bind:options="options"
                              v-if="totalmovimientoaceitescreditoturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientoaceitescreditoturno">
                              <v-btn @click="pdfservisioturno(13)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientobienestarturno" label="Total Bienestar" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientobienestarturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientobienestarturno">
                              <v-btn @click="pdfservisioturno(14)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="9" sm="10" md="10" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientotiendaturno" label="Total Tienda" readonly filled outlined
                              v-bind:options="options" v-if="totalmovimientotiendaturno" />
                          </v-col>

                          <v-col cols="3" sm="2" md="2" class="mt-n10 mx-auto">
                            <v-btn-toggle v-if="totalmovimientotiendaturno">
                              <v-btn @click="pdfservisioturno(15)">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="movimientototalturno" label="Total Turno" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modalrecibo" max-width="1000">
                  <v-card>
                    <v-col cols="12" md="12">
                      <b-card no-body>
                        <b-tabs card>
                          <b-tab title="Captura">
                            <v-expansion-panels v-model="panel" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  Recibos
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-alert shaped dark color="primary">
                                    Recibos
                                  </v-alert>

                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="6" md="6" class="mt-n10 mx-auto">
                                          <v-select v-model="reciboid" :items="reciboselect"
                                            v-on:change="selecttipoderecibo()"" label=" Tipo de Recibo"
                                            outlined></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" class="mt-n10 mx-auto">
                                          <v-text-field v-model="recibofolio" label="Folio Recibo" outlined
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                                          <v-text-field v-model="reciboimporte" label="Importe" outlined
                                            type="number"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                                          <v-textarea outlined name="input-7-4" label="Observacion"
                                            v-model="reciboconcepto"></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                          <v-text-field v-model="reciborecibe" label="Recibe" outlined></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                          <v-select v-model="autorizareciboid" :items="autorizarecibo" label="Autorizo"
                                            outlined v-on:change="selectautorizanombre()"></v-select>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                          <v-text-field v-model="reciboentrega" label="Entrega" outlined></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions class="mt-n10 mx-auto">
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardarrecibo"
                                      v-if="verguardarrecibo">Guardar</v-btn>
                                  </v-card-actions>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>
                          <b-tab title="Movimientos">
                            <v-expansion-panels v-model="panel" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  Recibos
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-list subheader two-line class="mt-n4 mx-auto">
                                    <v-list-item v-for="n in reciboturnoselect" :key="n.reciboid" class="mt-n4 mx-auto">
                                      <v-list-item-avatar>
                                        <v-icon class="grey lighten-1" dark>
                                          account_balance
                                        </v-icon>
                                      </v-list-item-avatar>

                                      <v-list-item-content>
                                        <v-list-item-title v-text="formatPrice(n.reciboimporte)"></v-list-item-title>
                                        <v-list-item-subtitle v-text="n.reciboconcepto"></v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 1">EFECTIVO</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 2">GASTO</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 3">RECORTE</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 4">RESTO</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 6">CAMBIO</v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="n.recibotipo == 7">DEPOSITO AL
                                          BANCO</v-list-item-subtitle>
                                      </v-list-item-content>

                                      <v-list-item-action>
                                        <v-btn icon>
                                          <v-icon @click="eliminarecibo(n)">delete</v-icon>
                                        </v-btn>
                                      </v-list-item-action>

                                      <v-list-item-action>
                                        <v-btn icon>
                                          <v-icon @click="editarecibo(n)">edit</v-icon>
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-list-item>
                                    <v-divider inset></v-divider>
                                  </v-list>

                                  <div class="text-center">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab dark large color="primary" @click="totalrestoturno"
                                          v-on="on">
                                          <v-icon dark>
                                            visibility
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Resto del Turno</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab dark large color="primary"
                                          @click="pdfrestobilletesmorrallanotas" v-on="on">
                                          <v-icon dark>
                                            print
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Imprime Resto</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab dark large color="primary" @click="pdfrecibos"
                                          v-on="on">
                                          <v-icon dark>
                                            payments
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Recibos del Turno</span>
                                    </v-tooltip>
                                  </div>

                                  <v-row>
                                    <v-col cols="12" sm="4" md="4" class="mt-n1 mx-auto">
                                      <vuetify-money v-model="efectivototal" label="Total Efectivo" readonly filled
                                        outlined v-bind:options="options" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4" class="mt-n1 mx-auto">
                                      <vuetify-money v-model="recibototal" label="Total Recibos" readonly filled
                                        outlined v-bind:options="options" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4" class="mt-n1 mx-auto">
                                      <vuetify-money v-model="restototal" label="Total Resto Fisico" readonly filled
                                        outlined v-bind:options="options" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                      <v-text-field v-model="totalefectivoigas" label="Total Igas" outlined
                                        type="number" @keyup.enter="restoigas()" @keydown.tab="restoigas()"
                                        v-on:blur="restoigas()"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                      <vuetify-money v-model="recibototal" label="Gastos Igas" readonly filled outlined
                                        v-bind:options="options" />
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                                      <vuetify-money v-model="totalrestoigas" label="Resto Igas" readonly filled
                                        outlined v-bind:options="options" />
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                                      <vuetify-money v-model="difigasyefectivo" label="Dif Efectivo Fisico IGAS"
                                        readonly filled outlined v-bind:options="options" />
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>
                        </b-tabs>
                      </b-card>
                    </v-col>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modaleditarecibo" max-width="500">
                  <v-card>
                    <v-col cols="12" md="12">
                      <b-card no-body>
                        <v-row>
                          <v-container>
                            <v-alert shaped dark color="primary">
                              Cambio Importe Recibo
                            </v-alert>

                            <v-col cols="12" sm="12" md="12" class="mt-n4 mx-auto">
                              <v-text-field v-model="reciboeditaimporte" label="Importe Recibo" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                              <v-select v-model="reciboeditaid" :items="reciboselect" label="Tipo de Recibo"
                                outlined></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                              <v-text-field v-model="reciboeditafolio" label="Folio Recibo" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                              <v-textarea outlined name="input-7-4" label="Observacion"
                                v-model="reciboeditaobservacion"></v-textarea>
                            </v-col>
                          </v-container>
                        </v-row>

                        <v-card-actions class="mt-n10 mx-auto">
                          <div class="flex-grow-1"></div>
                          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                          <v-btn color="blue darken-1" text @click="guardareditarecibo()">Guardar</v-btn>
                        </v-card-actions>
                      </b-card>
                    </v-col>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modaleditaservicio" max-width="500">
                  <v-card>
                    <v-col cols="12" md="12">
                      <b-card no-body>
                        <v-row>
                          <v-container>
                            <v-alert shaped dark color="primary">
                              Cambio Importe del Servicio
                            </v-alert>
                            <v-col cols="12" sm="12" md="12" class="mt-n4 mx-auto">
                              <v-text-field v-model="servicioeditaimporte" label="Importe Servicio" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 14" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditavalor" label="Litros" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 6" class="mt-n10 mx-auto">
                              <v-text-field v-model="movimientovalordolares" label="Costo de Dolares" outlined
                                type="number" readonly></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 6" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditavalor" label="Dolares" outlined type="number"
                                @keydown.tab="totaldolaresedita()" v-on:blur="totaldolaresedita()"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 1" class="mt-n10 mx-auto">
                              <v-select v-model="restobilleteefectivo" :items="restobilleteefectivoselect"
                                label="Efectivo" outlined></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditacliente" label="Numero de Cliente" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditacredito" label="Numero de Vale" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditaticket" label="Numero de Ticket"
                                outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditaunidad" label="Unidad" outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditalitros" label="Litros" outlined
                                type="number"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto" v-if="servicioid == 3">
                              <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible"
                                outlined></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditaautorizo" label="Autorizo o Cargo"
                                outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-text-field v-model="servicioeditadepartamento" label="Departamento"
                                outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="servicioid == 3" class="mt-n10 mx-auto">
                              <v-select v-model="creditovale" :items="creditovaleselect" label="Tipo de Crdeito"
                                outlined></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                              <v-textarea outlined name="input-7-4" label="Observacion"
                                v-model="servicioeditaobservacion"></v-textarea>
                            </v-col>
                          </v-container>
                        </v-row>

                        <v-card-actions class="mt-n10 mx-auto">
                          <div class="flex-grow-1"></div>
                          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                          <v-btn color="blue darken-1" text @click="guardareditamovimiento()">Guardar</v-btn>
                        </v-card-actions>
                      </b-card>
                    </v-col>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modalreclasificacion" max-width="500">
                  <v-card>
                    <v-col cols="12" md="12">
                      <b-card no-body>
                        <v-row>
                          <v-container>
                            <v-alert shaped dark color="primary">
                              Reclasificacion de Tickets por Cliente
                            </v-alert>

                            <v-col cols="12" sm="12" md="12" class=" mt-n4 mx-auto">
                              <v-autocomplete v-model="clienteigas" label="Buscar Cliente" :items="clientestodosselect"
                                item-text="clientenombre" item-value="clienteigas" @keydown.tab="clientetickets()"
                                v-on:blur="clientetickets()" outlined></v-autocomplete>
                            </v-col>


                            <v-col cols="12" sm="12" md="12" class=" mt-n4 mx-auto">
                              <v-autocomplete v-model="creditoticketvale" label="Buscar Ticket"
                                :items="clienteticketsselect" item-value="creditoticket" :item-text="itemText" outlined>
                                <template v-slot:item="{ item }">
                                  <div>
                                    <strong>Folio:</strong> {{ item.creditoticket }} |
                                    <strong>Importe:</strong> ${{ item.movimientoimporte }}
                                  </div>
                                </template>

                                <template v-slot:selection="{ item }">
                                  <div>
                                    Folio: {{ item.creditoticket }} | Importe: ${{ item.movimientoimporte }}
                                  </div>
                                </template>
                              </v-autocomplete>

                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                              <v-text-field v-model="valereclasificacion" label="Numero de Vale" outlined
                                type="number"></v-text-field>
                            </v-col>
                          </v-container>
                        </v-row>

                        <v-card-actions class="mt-n4 mx-auto">
                          <div class="flex-grow-1"></div>
                          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                          <v-btn color="primary" text @click="asignavale()">Asignar</v-btn>
                        </v-card-actions>
                      </b-card>
                    </v-col>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modalrestoturno" max-width="400">
                  <v-card>
                    <v-alert shaped dark color="primary">
                      Desglose de Resto
                    </v-alert>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" class="mt-n4 mx-auto">
                            <vuetify-money v-model="movimientoefectivoturno" label="Total Efectivo" readonly filled
                              outlined v-bind:options="options" v-if="totalmovimientoefectivoturno" />
                          </v-col>

                          <v-col cols="12" sm="8" md="8" class="mt-n10 mx-auto">
                            <vuetify-money v-model="restobilletes" label="Total Billetes" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>

                          <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn class="mx-2" fab dark large color="primary" @click="pdfrestobilletes" v-on="on">
                                  <v-icon dark>
                                    print
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>Imprime Resto Billetes</span>
                            </v-tooltip>
                          </v-col>

                          <v-col cols="12" sm="8" md="8" class="mt-n10 mx-auto">
                            <vuetify-money v-model="restomonedas" label="Total Resto Monedas" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>

                          <v-col cols="12" sm="4" md="4" class="mt-n10 mx-auto">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn class="mx-2" fab dark large color="primary" @click="pdfrestomonedas" v-on="on">
                                  <v-icon dark>
                                    print
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>Imprime Resto Monedas</span>
                            </v-tooltip>
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="abonomonedas" label="Abono Monedas" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="restonotas" label="Total Notas" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="restocheque" label="Total Cheques" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="mt-n10 mx-auto">
                            <vuetify-money v-model="restototal" label="Total Resto" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="mt-n10 mx-auto">
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="closerecto">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modelbilletesresto" max-width="400">
                  <v-card>
                    <v-alert shaped dark color="primary">
                      Desglose Resto Billetes
                    </v-alert>
                    <v-card-title>
                      <span class="headline">Desglose de los Billetes</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete20" label="Billetes de 20" outlined type="number"
                              @keydown.tab="calculaimportebillete()" v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete20total" label="Total de Billetes de 20" outlined
                              type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete50" label="Billetes de 50" outlined type="number"
                              @keydown.tab="calculaimportebillete()" v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete50total" label="Total de Billetes de 50" outlined
                              type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete100" label="Billetes de 100" outlined type="number"
                              @keydown.tab="calculaimportebillete()" v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete100total" label="Total de Billetes de 100" outlined
                              type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete200" label="Billetes de 200" outlined type="number"
                              @keydown.tab="calculaimportebillete()" v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete200total" label="Total de Billetes de 200" outlined
                              type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete500" label="Billetes de 500" outlined type="number"
                              @keydown.tab="calculaimportebillete()" v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete500total" label="Total de Billetes de 500" outlined
                              type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete1000" label="Billetes de 1000" outlined
                              type="number" @keydown.tab="calculaimportebillete()"
                              v-on:blur="calculaimportebillete()"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-text-field v-model="movimientobillete1000total" label="Total de Billetes de 1000"
                              outlined type="number"></v-text-field>
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <vuetify-money v-model="totalabonobilletes" label="Total Resto Billetes" readonly filled
                              outlined v-bind:options="options" />
                          </v-col>

                          <v-col cols="6" sm="6" md="6" class="py-0">
                            <vuetify-money v-model="restototalbilletes" label="Total Billetes" readonly filled outlined
                              v-bind:options="options" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="closerecto">Cancelar</v-btn>
                      <v-btn color="blue darken-1" text @click="actualizarbilletes">Actualizar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="modelcreditodetalle" max-width="1200">
                  <v-card>
                    <v-alert shaped dark color="primary">
                      Captura Detalle del Vale de Credito
                    </v-alert>
                    <v-card-title>
                      <span class="headline">Detalle</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <b-tabs card>
                          <b-tab title="Captura">
                            <v-expansion-panels v-model="creditodetallecaptura" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  Captura Detalle
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-row>

                                    <v-col cols="6" sm="6" md="6" class="mt-n2 mx-auto d-flex justify-end">
                                      <v-chip class="mt-n6 mx-auto" color="primary" large>
                                        Credito:
                                        {{ this.totaldetallecredito }}
                                      </v-chip>
                                    </v-col>

                                    <v-col cols="6" sm="6" md="6" class="mt-n2 mx-auto d-flex justify-start">
                                      <v-chip class="mt-n6 mx-auto" color="primary" large>
                                        Detalle: {{ calculardetalletotal }}
                                      </v-chip>
                                    </v-col>

                                  </v-row>


                                  <v-row>
                                    <v-col cols="12" sm="3" md="3" class="mt-n2 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="movimientoimporte" label="Importe" outlined
                                        type="number"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n2 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="clienteigas" label="Numero de Cliente" outlined
                                        type="number" @keyup.enter="clientebusca()"
                                        @keydown.tab="clientebusca()"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n2 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="credito" label="Numero de Vale" outlined
                                        type="number"></v-text-field @keyup.enter="tabimporte()"
                                        @keydown.tab="tabimporte()">
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" v-if="servicioid == 3" class="mt-n2 mx-auto">
                                      <v-select v-model="creditovale" :items="creditovaleselect" label="Tipo de Credito"
                                        outlined></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n12 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="creditoticket" label="Numero de Ticket"
                                        outlined></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n12 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="creditolitros" label="Numero de Litros" outlined
                                        type="number"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n12 mx-auto" v-if="servicioid == 3">
                                      <v-select v-model="combustibleid" :items="combustibleselect"
                                        label="Tipo de Combustible" outlined></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="3" md="3" class="mt-n12 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="creditounidad" label="Unidad" outlined></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" class="mt-n12 mx-auto" v-if="servicioid == 3">
                                      <v-text-field v-model="creditoautorizaocarga" label="Autorizo o Cargo"
                                        outlined></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-card-actions class="mt-n12 mx-auto">
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="closerecto">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardarcreditodetalle">Guardar</v-btn>
                                  </v-card-actions>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>

                          <b-tab title="Creditos">
                            <v-expansion-panels v-model="creditodetallecaptura" multiple>
                              <v-expansion-panel>
                                <v-expansion-panel-header>
                                  Listar Credito Detalle
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div class="text-center">
                                    <v-chip class="mt-n12 mx-auto" color="primary" large>
                                      Total Credito:
                                      {{ this.totaldetallecredito }}
                                    </v-chip>

                                    <v-chip class="mt-n12 mx-auto" color="primary" large>
                                      Total Detalle: {{ calculardetalletotal }}
                                    </v-chip>
                                  </div>
                                  <v-data-table v-model="selected" :headers="headers" :items="creditodetalle"
                                    :single-select="singleSelect" :search="search" item-key="creditodetalleid"
                                    show-select class="elevation-1 mt-n12 mx-auto">
                                    <template v-slot:top>
                                      <v-switch v-model="singleSelect" label="Seleccionar Todos"
                                        class="pa-3"></v-switch>
                                    </template>

                                    <template v-slot:item.creditoestatus="{ item }">
                                      <v-chip :color="getColor(item.creditoestatus)" dark>
                                        SIN PAGO
                                      </v-chip>
                                    </template>

                                    <template v-slot:item.combustibleid="{ item }">
                                      <v-chip :color="getColor(item.combustibleid)" dark v-if="item.combustibleid == 1">
                                        MAGNA
                                      </v-chip>
                                      <v-chip :color="getColor(item.combustibleid)" dark v-if="item.combustibleid == 2">
                                        PREMIUM
                                      </v-chip>

                                      <v-chip :color="getColor(item.combustibleid)" dark v-if="item.combustibleid == 3">
                                        DIESEL
                                      </v-chip>
                                    </template>

                                    <template v-slot:item.action="{ item }">
                                      <v-tooltip bottom>
                                        <template #activator="{ on }">
                                          <v-icon @click="eliminadetalleticket(item)" v-on="on">delete</v-icon>
                                        </template>
                                        <span>Elimina Ticket</span>
                                      </v-tooltip>
                                    </template>
                                  </v-data-table>

                                  <v-card-actions>
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="blue darken-1" text @click="closerecto">Cancelar</v-btn>
                                  </v-card-actions>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </b-tab>
                        </b-tabs>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <v-card-text>
                  <v-container fluid>
                    <v-row class="space-around mt-n8 mx-auto">
                      <v-col cols="6" sm="4" md="4" lg="2" class="py-0">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Efectivo
                          </div>
                          <v-img :src="require('../assets/1.jpg')" v-on:click="modelservicio(1)"
                            aspect-ratio="1"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Bancarias
                          </div>
                          <v-img :src="require('../assets/2.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(2)"></v-img>
                        </v-card>
                      </v-col>
                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Credito
                          </div>
                          <v-img :src="require('../assets/3.jpg')" v-on:click="modelservicio(3)"
                            aspect-ratio="1"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Acord
                          </div>
                          <v-img :src="require('../assets/4.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(4)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Efecticard
                          </div>
                          <v-img :src="require('../assets/5.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(5)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Dolares
                          </div>
                          <v-img :src="require('../assets/6.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(6)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Cupones
                          </div>
                          <v-img :src="require('../assets/7.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(7)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Cheque
                          </div>
                          <v-img :src="require('../assets/8.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(8)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Transferencias
                          </div>
                          <v-img :src="require('../assets/9.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(9)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Sodexo
                          </div>
                          <v-img :src="require('../assets/10.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(10)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            UltraGas
                          </div>
                          <v-img :src="require('../assets/11.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(11)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Aceites
                          </div>
                          <v-img :src="require('../assets/12.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(12)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Aceites Credito
                          </div>
                          <v-img :src="require('../assets/13.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(13)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Bienestar
                          </div>
                          <v-img :src="require('../assets/14.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(14)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="4" md="4" lg="2" class="py-1">
                        <v-card class="mx-auto" max-width="344">
                          <div class="text-h6 mb-1">
                            Tienda
                          </div>
                          <v-img :src="require('../assets/15.jpg')" aspect-ratio="1"
                            v-on:click="modelservicio(15)"></v-img>
                        </v-card>
                      </v-col>

                      <v-col cols="6" sm="6" md="6" lg="6" class="py-1">
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-app>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { Promise } from "q";

//import mykey from '../plugin_impresora_termica.js';
export default {
  data() {
    return {
      // Variable
      fechasistema: this.$store.state.usuario.fecha,
      //
      contrasenia1: "",
      contrasenia2: "",
      valida: 0,
      validamensaje: [],
      //
      modalservicio: 0,
      modalefectivo: 0,
      //
      liquidaid: "",
      liquidaselect: [],
      movimientoimporte: "",
      movimientoobservacion: "",

      date: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      menu: false,
      modal: false,
      menu2: false,
      despachadornombre: "",
      servicioid: "",
      bancariaacumulado: "",
      movimientoselect: [],
      panel: [0],
      creditodetallecaptura: [0],
      servicionombre: "",
      modaltotaldespachador: 0,
      //
      movimientoefectivo: 0,
      movimientobancaria: 0,
      movimientocredito: 0,
      movimientoacord: 0,
      movimientoefecticard: 0,
      movimientodolares: 0,
      movimientocupones: 0,
      movimientocheque: 0,
      movimientotransferencia: 0,
      movimientosodexo: 0,
      movimientoultragas: 0,
      movimientoaceites: 0,
      movimientoaceitescredito: 0,
      movimientobienestar: 0,
      movimientotienda: 0,
      //
      turnoid: 0,
      turnoselect: [],
      //
      modaltotalturno: 0,
      movimientoefectivoturno: 0,
      movimientobancariaturno: 0,
      movimientocreditoturno: 0,
      movimientoacordturno: 0,
      movimientoefecticardturno: 0,
      movimientodolaresturno: 0,
      movimientocuponesturno: 0,
      movimientochequeturno: 0,
      movimientotransferenciaturno: 0,
      movimientosodexoturno: 0,
      movimientoultragasturno: 0,
      movimientoaceitesturno: 0,
      movimientoaceitescreditoturno: 0,
      movimientobienestarturno: 0,
      movimientotiendaturno: 0,
      //
      modalrecibo: 0,
      reciboid: 2,
      reciboselect: [
        { text: "EFECTIVO", value: 1 },
        { text: "GASTOS", value: 2 },
        { text: "RECORTE", value: 3 },
        { text: "RESTO", value: 4 },
        { text: "CAMBIO", value: 5 },
        { text: "DEPOSITO AL BANCO", value: 6 },
        { text: "COMPLEMENTO DE PAGO", value: 7 },
        { text: "DOLARES", value: 8 },
      ],
      reciboimporte: "",
      reciboconcepto: "",
      recibofolio: "",
      reciboautorizo: "",
      reciborecibe: "-",
      reciboturnoselect: "",
      recibototal: "",
      efectivototal: "",
      restototal: "",
      verguardarrecibo: 1,
      reciboentrega: this.$store.state.usuario.usuarionombre,
      reciboeditaimporte: "",
      modaleditarecibo: 0,
      reciboedita: [],
      modaleditaservicio: 0,
      servicioeditaimporte: "",
      movimientoid: "",
      movimientofecha: "",
      clickservicioid: "",
      verguardarservicio: 1,
      // Ver Servicios por Isla
      islamovimientoefectivo: 0,
      islamovimientobancaria: 0,
      islamovimientocredito: 0,
      islamovimientoacord: 0,
      islamovimientoefecticard: 0,
      islamovimientodolares: 0,
      islamovimientocupones: 0,
      islamovimientocheque: 0,
      islamovimientotransferencia: 0,
      islamovimientosodexo: 0,
      islamovimientoultragas: 0,
      islamovimientoaceites: 0,
      islamovimientoaceitescredito: 0,
      islamovimientobienestar: 0,
      islamovimientotienda: 0,
      // Ver Servicios por Total
      totalmovimientoefectivoturno: 0,
      totalmovimientobancariaturno: 0,
      totalmovimientocreditoturno: 0,
      totalmovimientoacordturno: 0,
      totalmovimientoefecticardturno: 0,
      totalmovimientodolaresturno: 0,
      totalmovimientocuponesturno: 0,
      totalmovimientochequeturno: 0,
      totalmovimientotransferenciaturno: 0,
      totalmovimientosodexoturno: 0,
      totalmovimientoultragasturno: 0,
      totalmovimientoaceitesturno: 0,
      totalmovimientoaceitescreditoturno: 0,
      totalmovimientobienestarturno: 0,
      totalmovimientotiendaturno: 0,
      //
      movimientototalisla: 0,
      movimientototalturno: 0,
      movimientoefectivomasdolares: 0,
      //
      autorizarecibo: [],
      autorizareciboid: 1,
      autorizanombre: "Carlitos",
      //
      modalreclasificacion: 0,
      totalefectivo: 0,
      totalgastos: 0,
      totalliquidacion: 0,
      //
      servicioeditaobservacion: "",
      reciboeditaobservacion: "",
      reciboeditafolio: "",
      reciboeditaid: 1,

      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,
        precision: 2,
      },

      //
      totalefectivoigas: 0,
      totalgastoigas: 0,
      totalrestoigas: 0,
      difigasyefectivo: 0,
      url: process.env.VUE_APP_CLOUDINARY_URL_ROOT + "api/movimientos/",
      clienteigas: "",
      listarclienteid: 0,
      listarclienteselect: [],
      credito: "",
      servicioeditacliente: "",
      servicioeditacredito: "",
      servicioeditadepartamento: "",
      restobilleteefectivo: 1,
      restobilleteefectivoselect: [
        { text: "ABONO", value: 1 },
        { text: "RESTO BILLETES", value: 2 },
        { text: "RESTO MONEDAS", value: 3 },
        { text: "NOTAS", value: 4 },
        { text: "MORRALLA", value: 5 },
        { text: "CHEQUE CAMBIO", value: 6 },
      ],
      modalrestoturno: 0,
      restobilletes: 0,
      restomonedas: 0,
      restonotas: 0,
      restocheque: 0,
      abonomonedas: 0,
      creditoticket: "",
      combustibleid: 1,
      creditolitros: "",
      creditounidad: "",
      combustibleselect: [],
      creditoautorizaocarga: "",
      creditovale: 1,
      creditovaleselect: [
        { text: "TICKET", value: 1 },
        { text: "VALE", value: 2 },
        { text: "CUPON", value: 3 },
      ],
      servicioeditaticket: "",
      servicioeditaunidad: "",
      servicioeditalitros: "",
      servicioeditaautorizo: "",
      //
      movimientodolares: "",
      movimientovalordolares: "",
      movimientovalorbienestar: "",
      //
      modelbilletesresto: 0,
      movimientobillete20: 0,
      movimientobillete50: 0,
      movimientobillete100: 0,
      movimientobillete200: 0,
      movimientobillete500: 0,
      movimientobillete1000: 0,
      movimientobillete20total: 0,
      movimientobillete50total: 0,
      movimientobillete100total: 0,
      movimientobillete200total: 0,
      movimientobillete500total: 0,
      movimientobillete1000total: 0,
      restototalbilletes: "",
      totalabonobilletes: "",
      modelcreditodetalle: 0,
      singleSelect: false,
      selected: [],
      search: "",
      creditovigenteselect: [],
      headers: [
        { text: "Id", value: "creditodetalleid" },
        { text: "Fecha", value: "creditofecha" },
        { text: "Combustible", value: "combustibleid" },
        { text: "Ticket", value: "creditoticket" },
        { text: "Vale", value: "creditovale" },
        { text: "Importe", value: "creditoimporte" },
        { text: "Estatus", value: "creditoestatus" },
        { text: "Accion", value: "action", sortable: false },
      ],
      creditodetalle: [],
      totaldetallecredito: 0,
      servicioeditavalor: "",
      clientestodosselect: [],
      clienteactual: "",
      sucursalid: this.$store.state.usuario.sucursalid,
      departamentoid: 'NO APLICA',
      departamentoselect: [],
      vehiculostodosselect: [],
      vehiculoid: "",
      valereclasificacion: "",
      clienteticketsselect: [],
      creditoticketvale: "",
      transcript: "",
      mensaje: "",
      exito: false,

    };
  },

  computed: {
    calculardetalletotal: function () {
      var resultado = 0.0;
      for (var i = 0; i < this.creditodetalle.length; i++) {
        resultado =
          resultado + parseFloat(this.creditodetalle[i].creditoimporte);
      }
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(resultado);
    },
  },

  created() {
    this.autorizarecibonombres();
    this.selectgasolinatipo();
    this.selectparametro();
    this.clientetodos();
    this.selectturnofecha();
    this.selectdepartamento();
    this.vehiculostodos();
  },

  methods: {
    // Metodos Voz
    iniciarReconocimiento() {

       if (this.liquidaselect == "") {
        this.$swal("No se a Especificado el Turno");
        return;
      }

      if (this.liquidaid == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }


      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!SpeechRecognition) {
        alert('Tu navegador no soporta reconocimiento de voz');
        return;
      }

      const recognition = new SpeechRecognition();
      recognition.lang = 'es-ES';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onresult = (event) => {
        const texto = event.results[0][0].transcript.toLowerCase();
        this.transcript = texto;
        this.procesarComando(texto);
      };

      recognition.onerror = (event) => {
        console.error('Error de reconocimiento:', event.error);
        this.mensaje = 'Error al reconocer voz: ' + event.error;
        this.exito = false;
      };

      recognition.start();
    },

    procesarComando(texto) {

      const regex = /(bancaria|efectivo|cheque|cupones|créditos|accord|efecticar|dólares|transferencia|sodexo|ultra gas|aceites|crédito aceites|bienestar|tienda|imprime)\s+(.+)/i;
      const match = texto.match(regex);

      if (!match) {
        this.mensaje = 'No se reconoció un comando válido';
        this.exito = false;
        return;
      }

      const tipo = match[1].toLowerCase();
      const valorTexto = match[2].trim();

      const textoSinEspacios = valorTexto.replace(/[\s,]/g, "");

      // Intentar extraer número directamente
      const numero = textoSinEspacios.match(/[0-9]+(?:\.[0-9]{1,2})?/);
      let valor = 0;

      if (numero) {
        valor = parseFloat(numero[0]);
      } else {
        valor = this.convertirTextoANumero(valorTexto);

      }

      if (isNaN(valor) || valor <= 0) {
        this.mensaje = 'No se pudo interpretar el valor numérico.';
        this.exito = false;
        return;
      }

      this.enviarTransaccion(tipo, valor);
    },

    convertirTextoANumero(texto) {
      const map = {
        'cero': 0, 'uno': 1, 'una': 1, 'dos': 2, 'tres': 3, 'cuatro': 4, 'cinco': 5,
        'seis': 6, 'siete': 7, 'ocho': 8, 'nueve': 9, 'diez': 10, 'once': 11,
        'doce': 12, 'trece': 13, 'catorce': 14, 'quince': 15, 'veinte': 20,
        'treinta': 30, 'cuarenta': 40, 'cincuenta': 50, 'sesenta': 60,
        'setenta': 70, 'ochenta': 80, 'noventa': 90, 'cien': 100, 'ciento': 100,
        'doscientos': 200, 'trescientos': 300, 'cuatrocientos': 400,
        'quinientos': 500, 'seiscientos': 600, 'setecientos': 700,
        'ochocientos': 800, 'novecientos': 900, 'mil': 1000, 'millón': 1000000,
        'millones': 1000000
      };

      const palabras = texto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(' ');
      let total = 0;
      let parcial = 0;

      for (let palabra of palabras) {
        const valor = map[palabra];
        if (valor == null) continue;

        if (valor === 1000 || valor === 1000000) {
          if (parcial === 0) parcial = 1;
          total += parcial * valor;
          parcial = 0;
        } else {
          parcial += valor;
        }
      }

      return total + parcial;
    },

    async enviarTransaccion(tipo, valor) {

      if (tipo == "imprime") {
        this.pdfliquidacion();
      } else {
        this.guardarvoz(tipo, valor);
      }

    },

    pdfliquidacion() {
      window.open(
        this.url +
        "pdfmovimientodespachador/" +
        this.liquidaid +
        "/" +
        this.$store.state.usuario.fecha
      );
    },

    guardarvoz(tipo, valor) {

      if (tipo == "efectivo") {
        this.servicioid = 1;
      }
      if (tipo == "bancaria") {
        this.servicioid = 2;
      }

      if (tipo == "créditos") {
        this.servicioid = 3;
      }

      if (tipo == "accord") {
        this.servicioid = 4;
      }

      if (tipo == "efecticar") {
        this.servicioid = 5;
      }

      if (tipo == "dólares") {
        this.servicioid = 6;
      }

      if (tipo == "cupones") {
        this.servicioid = 7;
      }

      if (tipo == "cheque") {
        this.servicioid = 8;
      }

      if (tipo == "transferencia") {
        this.servicioid = 9;
      }

      if (tipo == "sodexo") {
        this.servicioid = 10;
      }

      if (tipo == "ultra gas") {
        this.servicioid = 11;
      }

      if (tipo == "aceites") {
        this.servicioid = 12;
      }

      if (tipo == "crédito aceites") {
        this.servicioid = 13;
      }

      if (tipo == "bienestar") {
        this.servicioid = 14;
      }

      if (tipo == "tienda") {
        this.servicioid = 15;
      }

    

      


      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;



      var totalmovimiento = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(valor);


      


      me.$swal({
        icon: "warning",
        title: "Estas Seguro de GUARDAR",

         html: `
          <div style="font-size:32px; font-weight:bold; margin-bottom:10px;">
            ${this.despachadornombre}
          </div>

          <div style="font-size:26px; font-weight:600; margin-bottom:15px;">
            ${tipo}
          </div>

          <p style="font-size:18px;">
            Operación por la Cantidad de: <strong>${totalmovimiento}</strong>
          </p>
        `,


       
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/movimientos/crear",
              {
                liquidacionid: me.liquidaid,
                servicioid: me.servicioid,
                movimientoimporte: valor,
                //movimientoobservacion: "",
                movimientofecha: me.$store.state.usuario.fecha,
                turnoid: me.turnoid,
                //clienteigas: me.clienteigas,
                //credito: me.credito,
                //restobilleteefectivo: me.restobilleteefectivo,
                //creditoticket: me.creditoticket,
                combustibleid: 1,
                //creditolitros: me.creditolitros,
                //creditounidad: me.creditounidad,
                //creditoautorizaocarga: me.creditoautorizaocarga,
                //creditovale: me.creditovale,
                //movimientovalor: me.movimientodolares,
                //movimientoparametrovalor: me.movimientovalordolares,
                //sucursalid: me.sucursalid,
                //departamentoid: me.departamentoid,
              },
              configuracion
            )
            .then(function (response) {
              me.$swal("Guardado", "Se a Guardado: " + tipo + " por la Cantidad de: " + totalmovimiento, "success");
              me.transcript = "";
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.$swal("No se Inserto El Registro Checar");
              }
            });
        }
      });









    },

    // Termina Guardar Voz



    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    itemText(item) {
      if (!item || typeof item !== 'object') return '';
      return `Folio: ${item.creditoticket} | Importe: ${item.movimientoimporte}`;
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103"; // Verde
      if (socioestatus == 2) return "#DA0707"; // Rojo
    },

    apagar() {
      this.islamovimientoefectivo = 0;
      this.islamovimientobancaria = 0;
      this.islamovimientocredito = 0;
      this.islamovimientoacord = 0;
      this.islamovimientoefecticard = 0;
      this.islamovimientodolares = 0;
      this.islamovimientocupones = 0;
      this.islamovimientocheque = 0;
      this.islamovimientotransferencia = 0;
      this.islamovimientosodexo = 0;
      this.islamovimientoultragas = 0;
      this.islamovimientoaceites = 0;
      this.islamovimientoaceitescredito = 0;
      this.islamovimientobienestar = 0;
      this.islamovimientotienda = 0;
      this.totalmovimientoefectivoturno = 0;
      this.totalmovimientobancariaturno = 0;
      this.totalmovimientocreditoturno = 0;
      this.totalmovimientoacordturno = 0;
      this.totalmovimientoefecticardturno = 0;
      this.totalmovimientodolaresturno = 0;
      this.totalmovimientocuponesturno = 0;
      this.totalmovimientochequeturno = 0;
      this.totalmovimientotransferenciaturno = 0;
      this.totalmovimientosodexoturno = 0;
      this.totalmovimientoultragasturno = 0;
      this.totalmovimientoaceitesturno = 0;
      this.totalmovimientoaceitescreditoturno = 0;
      this.totalmovimientobienestarturno = 0;
      this.totalmovimientotiendaturno = 0;
    },


    // metodo listar
    selectturnofecha() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/turnos/listarporfecha/" + me.date, configuracion)
        .then(function (response) {
          listaArray = response.data.turno;
          me.turnoselect = [];
          listaArray.map(function (x) {
            me.turnoselect.push({
              text: x.turnonumeronombre,
              value: x.turnonumeronumero,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selecttipoderecibo() {

      if (this.reciboid == 1) {
        this.reciboconcepto = "EFECTIVO";
      }
      if (this.reciboid == 2) {
        this.reciboconcepto = "GASTOS";
      }
      if (this.reciboid == 3) {
        this.reciboconcepto = "RECORTE";
      }
      if (this.reciboid == 4) {
        this.reciboconcepto = "RESTO";
      }
      if (this.reciboid == 5) {
        this.reciboconcepto = "CAMBIO";
      }
      if (this.reciboid == 6) {
        this.reciboconcepto = "DEPOSITO AL BANCO";
      }
      if (this.reciboid == 7) {
        this.reciboconcepto = "COMPLEMENTO DE PAGO";
      }
      if (this.reciboid == 8) {
        this.reciboconcepto = "DOLARES";
      }
    },

    capturabilleresresto(n) {
      this.modelbilletesresto = 1;
      this.totalabonobilletes = n.movimientoimporte;
      this.selectlistarbilletes(n);
      this.movimientoid = n.movimientoid;
      this.liquidacionid = n.liquidacionid;
    },

    capturacreditodetalle(item) {
      this.modelcreditodetalle = 1;
      this.creditovale = item.creditovale;
      this.credito = item.credito;
      this.turnoid = item.turnoid;
      this.movimientoid = item.movimientoid;
      this.liquidacionid = item.liquidacionid;
      this.clienteigas = item.clienteigas;
      this.totaldetallecredito = item.movimientoimporte;
      this.listarcreditodetalle();
    },

    selectlistarbilletes(n) {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientobilletes/listarbilletes/" +
          n.movimientoid +
          "/" +
          n.liquidacionid +
          "/" +
          n.movimientofecha,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.movimientobillete;
          me.movimientobillete20 = listaArray.movimientobillete20;
          me.movimientobillete50 = listaArray.movimientobillete50;
          me.movimientobillete100 = listaArray.movimientobillete100;
          me.movimientobillete200 = listaArray.movimientobillete200;
          me.movimientobillete500 = listaArray.movimientobillete500;
          me.movimientobillete1000 = listaArray.movimientobillete1000;
          me.calculaimportebillete();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    calculaimportebillete() {
      this.movimientobillete20total = parseFloat(this.movimientobillete20) * 20;
      this.movimientobillete50total = parseFloat(this.movimientobillete50) * 50;
      this.movimientobillete100total =
        parseFloat(this.movimientobillete100) * 100;
      this.movimientobillete200total =
        parseFloat(this.movimientobillete200) * 200;
      this.movimientobillete500total =
        parseFloat(this.movimientobillete500) * 500;
      this.movimientobillete1000total =
        parseFloat(this.movimientobillete1000) * 1000;

      this.restototalbilletes =
        this.movimientobillete20total +
        this.movimientobillete50total +
        this.movimientobillete100total +
        this.movimientobillete200total +
        this.movimientobillete500total +
        this.movimientobillete1000total;
    },

    valeoticket() {
      if (this.credito == 0) {
        this.creditovale = 1;
        this.$refs.focoimporte.focus();

      }
      if (this.credito > 0) {
        this.creditovale = 2;
        this.$refs.focoimporte.focus();
      }
    },

    actualizarbilletes() {
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      if (me.restototalbilletes != me.totalabonobilletes) {
        this.$swal("EL Resto no es Igual En Denominaciones");
        return;
      }

      axios
        .post(
          "api/movimientobilletes/actualizar",
          {
            movimientoid: me.movimientoid,
            liquidacionid: me.liquidacionid,
            movimientobilletefecha: me.date,
            movimientobillete20: me.movimientobillete20,
            movimientobillete50: me.movimientobillete50,
            movimientobillete100: me.movimientobillete100,
            movimientobillete200: me.movimientobillete200,
            movimientobillete500: me.movimientobillete500,
            movimientobillete1000: me.movimientobillete1000,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiarbilletes();
          //me.listar();
          me.$swal("Recibo Actualizado con Exito");
          me.modaleditarecibo = 0;
          me.saldoefectivoturno(1);
          me.recibosturno();
          me.saldorecibo();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    limpiarbilletes() {
      this.movimientobillete20 = 0;
      this.movimientobillete50 = 0;
      this.movimientobillete100 = 0;
      this.movimientobillete200 = 0;
      this.movimientobillete500 = 0;
      this.movimientobillete1000 = 0;
      this.movimientobillete20total = 0;
      this.movimientobillete50total = 0;
      this.movimientobillete100total = 0;
      this.movimientobillete200total = 0;
      this.movimientobillete500total = 0;
      this.movimientobillete1000total = 0;
      this.restototalbilletes = 0;
      this.totalabonobilletes = 0;
      this.modelbilletesresto = 0;
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectdepartamento() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/departamentos/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.departamento;
          listaArray.map(function (x) {
            me.departamentoselect.push({
              text: x.departamentonombre,
              value: x.departamentonombre,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectparametro() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/parametros/parametroid/" + 2, configuracion)
        .then(function (response) {
          listaArray = response.data.parametro;
          me.movimientovalordolares = listaArray.parametrovalor;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectrestobilletes() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/parametros/parametroid/" + 2, configuracion)
        .then(function (response) {
          listaArray = response.data.parametro;
          me.movimientovalordolares = listaArray.parametrovalor;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    async reclasificacion() {
      this.modalreclasificacion = 1;
      this.creditoticketvale = "";
      this.clienteticketsselect = [];
      this.valereclasificacion = "";

    },

    asignavale() {

      if (this.creditoticketvale == "") {
        this.$swal("No se a Especificado el Ticket");
        return;
      }

      if (this.valereclasificacion == "") {
        this.$swal("No se a Especificado el Vale");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .post(
          "api/movimientos/asignavale",
          {
            creditoticket: me.creditoticketvale,
            valereclasificacion: me.valereclasificacion
          },
          configuracion
        )
        .then(function (response) {

          me.$swal("Ticket Asigando al Vale");
          me.creditoticketvale = "";
          me.clienteticketsselect = [];
          me.clientetickets();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    clientebusca() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listarid/" + me.clienteigas)
        .then(function (response) {
          me.movimientoobservacion = response.data.cliente.clientenombre;
          //me.$refs.fococredito.focus();
          me.$refs.fococredito.focus.focus();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    clientetickets() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/movimientos/clientetickets/" + me.date + "/" + me.clienteigas)
        .then(function (response) {
          me.clienteticketsselect = response.data.movimiento;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    vehiculobusca() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/vehiculos/listarvehiculosid/" + me.creditounidad)
        .then(function (response) {

          //me.creditounidad = response.data.vehiculo.vehiculonombre;
          me.combustibleid = response.data.vehiculo.combustibleid;
          //me.$refs.fococredito.focus();
          //me.$refs.fococredito.focus.focus();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    clientetodos() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listar", configuracion)
        .then(function (response) {
          me.clientestodosselect = response.data.cliente;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    vehiculostodos() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/vehiculos/listarvehiculos", configuracion)
        .then(function (response) {
          me.vehiculostodosselect = response.data.vehiculo;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    reciboefectivo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/recibos/reciboefectivo/" + me.date, configuracion)
        .then(function (response) {
          listaArray = response.data.recibo;
          listaArray.map(function (x) {
            me.totalefectivo = x.total;
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    recibogasto() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/recibos/recibogasto/" + me.date, configuracion)
        .then(function (response) {
          listaArray = response.data.recibo;
          listaArray.map(function (x) {
            me.totalgastos = x.total;
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    reciboliquida() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/recibos/reciboliquida/" + me.date, configuracion)
        .then(function (response) {
          listaArray = response.data.recibo;
          listaArray.map(function (x) {
            me.totalliquidacion = x.total;
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    limpiar() {
      this.valida = 0;
      this.validamensaje = [];
      this.movimientoimporte = "";
      this.movimientoobservacion = "";
      this.clienteigas = "";
      this.restobilleteefectivo = 1;
      this.creditoticket = "";
      this.combustibleid = 1;
      this.creditolitros = "";
      this.creditounidad = "";
      this.movimientodolares = "";
      this.servicioeditavalor = "";
      this.reciboid = 2;
      this.reciboeditaid = 2;
      this.departamentoid = 'NO APLICA';
    },

    limpiarvale() {
      if (this.credito != 0) {
        this.credito = "";
        //this.movimientoobservacion = "";
        this.creditovale = 1;
      }
      this.valida = 0;
      this.validamensaje = [];
      this.movimientoimporte = "";
      //this.movimientoobservacion = "";
      //this.clienteigas = "";
      this.restobilleteefectivo = 1;
      this.creditoticket = "";
      //this.combustibleid = 1;
      this.creditolitros = "";
      this.creditounidad = "";
      this.movimientodolares = "";
      this.servicioeditavalor = "";
      //this.departamentoid='NO APLICA';
    },

    limpiarcreditodetalle() {
      this.valida = 0;
      this.validamensaje = [];
      this.movimientoimporte = "";
      this.movimientoobservacion = "";
      this.restobilleteefectivo = 1;
      this.creditoticket = "";
      this.combustibleid = 1;
      this.creditolitros = "";
      this.creditounidad = "";
      this.movimientodolares = "";
    },

    limpiarcredito() {
      this.credito = "";
      this.creditoautorizaocarga = "";
      this.creditovale = 1;
      this.clienteigas = "";
      this.creditoticket = "";
      this.combustibleid = 1;
      this.creditolitros = "";
      this.creditounidad = "";
      this.movimientoimporte = "";
      this.movimientoobservacion = "";
      this.departamentoid = 'NO APLICA';
    },

    formadeabono() {
      if (this.restobilleteefectivo == 1) {
        this.movimientoobservacion = "ABONO";
      }
      if (this.restobilleteefectivo == 2) {
        this.movimientoobservacion = "RESTO BILLETES";
      }
      if (this.restobilleteefectivo == 3) {
        this.movimientoobservacion = "RESTO MONEDAS";
      }
      if (this.restobilleteefectivo == 4) {
        this.movimientoobservacion = "NOTA";
      }
      if (this.restobilleteefectivo == 5) {
        this.movimientoobservacion = "MORRALLA";
      }
    },

    tabimporte() {
      this.$refs.focoimportecredito.focus.focus();
    },

    autorizarecibonombres() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/autorizarecibos/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.autorizarecibo;
          listaArray.map(function (x) {
            me.autorizarecibo.push({
              text: x.autorizarecibonombre,
              value: x.autorizareciboid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    totalrestoturno() {
      this.modalrestoturno = 1;
      this.saldorestoturno();
    },

    saldorestoturno() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientos/saldorestoturno/" + me.date + "/" + me.turnoid,
          configuracion
        )
        .then(function (response) {
          me.restobilletes = response.data.billetes;
          me.abonomonedas = response.data.abonomonedas;
          me.restomonedas = response.data.monedas;
          me.restonotas = response.data.notas;
          me.restocheque = response.data.cheques;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listarclientes() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientos/listarcredito/3/" + me.turnoid + "/" + me.date,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.clientes;
          listaArray.map(function (x) {
            me.listarclienteselect.push({
              text: x.clientenombre,
              value: x.clienteigas,
            });
          });
          me.listarclienteselect.push({
            text: "TODOS",
            value: 1,
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectautorizanombre() {
      this.autorizanombre = event.target.textContent;
    },

    totaldolares() {
      this.movimientoimporte = (
        parseFloat(this.movimientodolares) *
        parseFloat(this.movimientovalordolares)
      ).toFixed(2);
      this.movimientoobservacion =
        "DOLARES: " +
        this.movimientodolares +
        "X" +
        this.movimientovalordolares;
    },

    totaldolaresedita() {
      this.servicioeditaimporte = (
        parseFloat(this.movimientovalordolares) *
        parseFloat(this.servicioeditavalor)
      ).toFixed(2);
      this.servicioeditaobservacion =
        "DOLARES: " +
        this.servicioeditavalor +
        "X" +
        this.movimientovalordolares;
    },

    limpiarrecibos() {
      this.reciboid = "";
      this.reciboimporte = "";
      this.reciboconcepto = "";
      this.recibofolio = "";
      this.reciboautorizo = "";
      this.reciborecibe = "";
      this.autorizanombre = "Carlitos";
      this.autorizareciboid = "";
    },

    turnos() {
      (this.turnoid = ""), (this.liquidaselect = []);
      this.liquidaid = "";
    },

    modelservicio(serid) {
      if (this.liquidaselect == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }

      if (this.liquidaid == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }

      this.limpiar();

      if (serid == 1) {
        this.modalservicio = 1;
        this.servicioid = 1;
        this.servicionombre = "Efectivo";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 2) {
        this.modalservicio = 1;
        this.servicioid = 2;
        this.servicionombre = "Bancarias";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 3) {
        this.modalservicio = 1;
        this.servicioid = 3;
        this.servicionombre = "Credito";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 4) {
        this.modalservicio = 1;
        this.servicioid = 4;
        this.servicionombre = "Acord";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 5) {
        this.modalservicio = 1;
        this.servicioid = 5;
        this.servicionombre = "Efecticard";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 6) {
        this.modalservicio = 1;
        this.servicioid = 6;
        this.servicionombre = "Dolares";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 7) {
        this.modalservicio = 1;
        this.servicioid = 7;
        this.servicionombre = "Cupones";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 8) {
        this.modalservicio = 1;
        this.servicioid = 8;
        this.servicionombre = "Cheques";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 9) {
        this.modalservicio = 1;
        this.servicioid = 9;
        this.servicionombre = "Transferencias";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 10) {
        this.modalservicio = 1;
        this.servicioid = 10;
        this.servicionombre = "Sodexo";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 11) {
        this.modalservicio = 1;
        this.servicioid = 11;
        this.servicionombre = "UltraGas";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 12) {
        this.modalservicio = 1;
        this.servicioid = 12;
        this.servicionombre = "Aceites";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 13) {
        this.modalservicio = 1;
        this.servicioid = 13;
        this.servicionombre = "Aceites Credito";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 14) {
        this.modalservicio = 1;
        this.servicioid = 14;
        this.servicionombre = "Bienestar";
        this.saldoservicio();
        this.servicio();
      }
      if (serid == 15) {
        this.modalservicio = 1;
        this.servicioid = 15;
        this.servicionombre = "Tienda";
        this.saldoservicio();
        this.servicio();
      }
    },

    recibos() {
      if (this.turnoid == 0) {
        this.$swal("No se a Especificado el Turno");
        return;
      }
      this.modalrecibo = 1;
      this.reciboid = 2;
      this.reciboeditaid = 2;
      this.recibosturno();
      this.saldorecibo();
      this.saldoefectivoturno(1);
    },

    recibosturno() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/recibos/reciboturno/" + me.date + "/" + me.turnoid,
          configuracion
        )
        .then(function (response) {
          me.reciboturnoselect = response.data.recibo;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    editarecibo(recibo) {
      this.reciboedita = [];
      this.modaleditarecibo = 1;
      this.reciboedita = recibo;
      this.reciboid = this.reciboedita.reciboid;
      this.reciboeditaimporte = this.reciboedita.reciboimporte;
      this.reciboeditaid = recibo.recibotipo;
      this.reciboeditafolio = recibo.recibofolio;
      this.reciboeditaobservacion = recibo.reciboconcepto;
    },

    editarservicio(ser) {
      this.modaleditaservicio = 1;
      (this.movimientoid = ""), (this.movimientofecha = "");
      this.servicioid = "";
      this.movimientoid = ser.movimientoid;
      this.movimientofecha = ser.movimientofecha;
      this.servicioeditaimporte = ser.movimientoimporte;
      this.servicioid = ser.servicioid;
      this.servicioeditacliente = ser.clienteigas;
      this.servicioeditacredito = ser.credito;
      this.restobilleteefectivo = ser.restobilleteefectivo;
      this.servicioeditaticket = ser.creditoticket;
      this.servicioeditaunidad = ser.creditounidad;
      this.servicioeditalitros = ser.creditolitros;
      this.servicioeditaautorizo = ser.creditoautorizaocarga;
      this.combustibleid = ser.combustibleid;
      this.creditovale = ser.creditovale;
      this.servicioeditaobservacion = ser.movimientoobservacion;
      this.servicioeditavalor = ser.movimientovalor;
      this.servicioeditadepartamento = ser.departamento;
    },

    imprimeservicio(ser) {
      window.open(
        this.url +
        "pdfservicio/" +
        ser.movimientoid +
        "/" +
        ser.liquidacionid +
        "/" +
        ser.movimientofecha +
        "/" +
        ser.servicioid
      );
    },

    imprimevarios() {
      window.open(
        this.url +
        "pdfvarios/" +
        this.date
      );
    },

    guardareditarecibo() {
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .post(
          "api/recibos/actualizar",
          {
            reciboid: me.reciboid,
            reciboimporte: me.reciboeditaimporte,
            recibotipo: me.reciboeditaid,
            recibofolio: me.reciboeditafolio,
            reciboconcepto: me.reciboeditaobservacion,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          //me.listar();
          me.$swal("Recibo Actualizado con Exito");
          me.modaleditarecibo = 0;
          me.saldoefectivoturno(1);
          me.recibosturno();
          me.saldorecibo();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardareditamovimiento() {
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      axios
        .post(
          "api/movimientos/actualizar",
          {
            movimientoid: me.movimientoid,
            liquidacionid: me.liquidaid,
            movimientoimporte: me.servicioeditaimporte,
            movimientofecha: me.movimientofecha,
            movimientoobservacion: me.servicioeditaobservacion,
            servicioid: me.servicioid,
            clienteigas: me.servicioeditacliente,
            credito: me.servicioeditacredito,
            restobilleteefectivo: me.restobilleteefectivo,
            creditoticket: me.servicioeditaticket,
            combustibleid: me.combustibleid,
            creditolitros: me.servicioeditalitros,
            creditounidad: me.servicioeditaunidad,
            creditoautorizaocarga: me.servicioeditaautorizo,
            creditovale: me.creditovale,
            movimientovalor: me.servicioeditavalor,
            movimientoparametrovalor: me.movimientovalordolares,
            departamento: me.servicioeditadepartamento,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          //me.listar();
          me.$swal("Movimiento Actualizado con Exito");
          me.modaleditaservicio = 0;
          me.modelservicio(me.servicioid);
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    restoigas() {
      this.totalrestoigas =
        parseFloat(this.totalefectivoigas) - parseFloat(this.recibototal);
      this.difigasyefectivo =
        parseFloat(this.totalrestoigas) - parseFloat(this.restototal);
    },

    pdfservisioturno(servicioid) {
      if (servicioid == 3) {
        window.open(
          this.url +
          "pdfcredito/" +
          servicioid +
          "/" +
          this.turnoid +
          "/" +
          this.date +
          "/" +
          this.listarclienteid
        );
      } else if (servicioid == 2) {
        window.open(
          this.url +
          "pdfbancarias/" +
          servicioid +
          "/" +
          this.turnoid +
          "/" +
          this.date
        );
      } else if (servicioid == 1) {
        window.open(
          this.url +
          "pdfabonos/" +
          servicioid +
          "/" +
          this.turnoid +
          "/" +
          this.date
        );
      } else {
        window.open(
          this.url + "pdf/" + servicioid + "/" + this.turnoid + "/" + this.date
        );
      }
    },

    pdfrelacioncredito() {
      if (this.listarclienteid == "") {
        this.$swal("No se a Especificado el Cliente de Credito");
        return;
      }

      window.open(
        this.url +
        "pdfrelacioncredito/" +
        this.date +
        "/" +
        this.listarclienteid
      );
    },

    pdfcreditoisla() {
      if (this.listarclienteid == "") {
        this.$swal("No se a Especificado el Cliente de Credito");
        return;
      }

      window.open(
        this.url +
        "pdfcreditoisla/" +
        this.date
      );
    },

    pdfdepartamento() {
      if (this.listarclienteid == "") {
        this.$swal("No se a Especificado el Cliente de Credito");
        return;
      }

      window.open(
        this.url +
        "pdfdepartamento/" + this.listarclienteid + "/" +
        this.date
      );
    },

    pdfpresidencia() {
      if (this.listarclienteid == "") {
        this.$swal("No se a Especificado el Cliente de Credito");
        return;
      }



      window.open(
        this.url +
        "pdfcreditomunicipio/" +
        3 +
        "/" +
        this.turnoid +
        "/" +
        this.date +
        "/" +
        this.listarclienteid
      );
    },

    pdfservisioisla(servicioid) {
      window.open(
        this.url +
        "pdfisla/" +
        servicioid +
        "/" +
        this.turnoid +
        "/" +
        this.date +
        "/" +
        this.liquidaid
      );
    },

    pdfrecibos() {
      window.open(this.url + "pdfrecibos/" + this.turnoid + "/" + this.date);
    },

    pdfrestomonedas() {
      window.open(
        this.url + "pdfrestomonedas/" + this.turnoid + "/" + this.date
      );
    },

    pdfrestobilletes() {
      window.open(
        this.url + "pdfrestobilletes/" + this.turnoid + "/" + this.date
      );
    },

    pdfrestobilletesmorrallanotas() {
      window.open(this.url + "pdfrestoturno/" + this.turnoid + "/" + this.date);
    },

    eliminarecibo(recibo) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text: "Recibo: " + recibo.reciboconcepto,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/recibos/eliminar",
              {
                reciboid: recibo.reciboid,
              },
              configuracion
            )
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              //me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });
        }
      });
    },

    eliminadetalleticket(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text: "Ticket: " + item.creditoticket,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/creditodetalles/eliminar",
              {
                creditodetalleid: item.creditodetalleid,
              },
              configuracion
            )
            .then(function (response) {
              me.limpiarcreditodetalle();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.listarcreditodetalle();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });
        }
      });
    },

    eliminarmovimiento(movimiento) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Actualiza
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text: "Movimiento: " + movimiento.movimientoimporte,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/movimientos/eliminar",
              {
                movimientoid: movimiento.movimientoid,
                liquidacionid: movimiento.liquidacionid,
                movimientofecha: movimiento.movimientofecha,
                servicioid: movimiento.servicioid,
              },
              configuracion
            )
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              //me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });
        }
      });
    },

    eliminaservicio(servicio) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text: "Recibo: " + recibo.reciboconcepto,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .post(
              "api/recibos/eliminar",
              {
                reciboid: recibo.reciboid,
              },
              configuracion
            )
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              //me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });
        }
      });
    },

    liquida() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/liquidaciones/listarfecha/" + me.date + "/" + me.turnoid,
          configuracion
        )
        .then(function (response) {
          me.liquidaselect = [];
          listaArray = response.data.liquidacion;
          listaArray.map(function (x) {
            me.liquidaselect.push({
              text: x.liquidacionnombre + " - ISLA: " + x.liquidacionisla,
              value: x.liquidacionid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    totalturnofecha() {
      this.modaltotalturno = 1;
    },

    selectturno() {
      this.$swal("Turno No." + this.turnoid + " Seleccionado");
      this.liquida();
    },

    saldoservicio() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientos/saldoservisio/" + me.liquidaid + "/" + me.servicioid,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.movimiento;
          listaArray.map(function (x) {
            me.bancariaacumulado = x.total;
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    saldorecibo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/recibos/saldoreciboturno/" + me.date + "/" + me.turnoid,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.recibo;
          listaArray.map(function (x) {
            me.recibototal = x.total;
          });
          me.restototal = (
            parseFloat(me.efectivototal) - parseFloat(me.recibototal)
          ).toFixed(2);
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    saldototalisla() {
      let me = this;
      me.movimientototalisla =
        parseFloat(me.movimientoefectivo) +
        parseFloat(me.movimientobancaria) +
        parseFloat(me.movimientocredito) +
        parseFloat(me.movimientoacord) +
        parseFloat(me.movimientoefecticard) +
        parseFloat(me.movimientodolares) +
        parseFloat(me.movimientocupones) +
        parseFloat(me.movimientocheque) +
        parseFloat(me.movimientotransferencia) +
        parseFloat(me.movimientosodexo) +
        parseFloat(me.movimientoultragas) +
        parseFloat(me.movimientoaceites) +
        parseFloat(me.movimientoaceitescredito) +
        parseFloat(me.movimientobienestar);
    },

    async saldoservicioisla(servicioid) {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get(
          "api/movimientos/saldoservisio/" + me.liquidaid + "/" + servicioid,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.movimiento;
          listaArray.map(function (x) {
            if (servicioid == 1) {
              me.movimientoefectivo = x.total;
              if (me.movimientoefectivo == 0) {
                me.islamovimientoefectivo = 0;
                me.movimientoefectivo = 0;
              } else {
                me.islamovimientoefectivo = 1;
              }
            }
            if (servicioid == 2) {
              me.movimientobancaria = x.total;
              if (me.movimientobancaria == 0) {
                me.islamovimientobancaria = 0;
                me.movimientobancaria = 0;
              } else {
                me.islamovimientobancaria = 1;
              }
            }
            if (servicioid == 3) {
              me.movimientocredito = x.total;
              if (me.movimientocredito == 0) {
                me.islamovimientocredito = 0;
                me.movimientocredito = 0;
              } else {
                me.islamovimientocredito = 1;
              }
            }
            if (servicioid == 4) {
              me.movimientoacord = x.total;
              if (me.movimientoacord == 0) {
                me.islamovimientoacord = 0;
                me.movimientoacord = 0;
              } else {
                me.islamovimientoacord = 1;
              }
            }
            if (servicioid == 5) {
              me.movimientoefecticard = x.total;
              if (me.movimientoefecticard == 0) {
                me.islamovimientoefecticard = 0;
                me.movimientoefecticard = 0;
              } else {
                me.islamovimientoefecticard = 1;
              }
            }
            if (servicioid == 6) {
              me.movimientodolares = x.total;
              if (me.movimientodolares == 0) {
                me.islamovimientodolares = 0;
                me.movimientodolares = 0;
              } else {
                me.islamovimientodolares = 1;
              }
            }
            if (servicioid == 7) {
              me.movimientocupones = x.total;
              if (me.movimientocupones == 0) {
                me.islamovimientocupones = 0;
                me.movimientocupones = 0;
              } else {
                me.islamovimientocupones = 1;
              }
            }
            if (servicioid == 8) {
              me.movimientocheque = x.total;
              if (me.movimientocheque == 0) {
                me.islamovimientocheque = 0;
                me.movimientocheque = 0;
              } else {
                me.islamovimientocheque = 1;
              }
            }
            if (servicioid == 9) {
              me.movimientotransferencia = x.total;
              if (me.movimientotransferencia == 0) {
                me.islamovimientotransferencia = 0;
                me.movimientotransferencia = 0;
              } else {
                me.islamovimientotransferencia = 1;
              }
            }
            if (servicioid == 10) {
              me.movimientosodexo = x.total;
              if (me.movimientosodexo == 0) {
                me.islamovimientosodexo = 0;
                me.movimientosodexo = 0;
              } else {
                me.islamovimientosodexo = 1;
              }
            }
            if (servicioid == 11) {
              me.movimientoultragas = x.total;
              if (me.movimientoultragas == 0) {
                me.islamovimientoultragas = 0;
                me.movimientoultragas = 0;
              } else {
                me.islamovimientoultragas = 1;
              }
            }
            if (servicioid == 12) {
              me.movimientoaceites = x.total;
              if (me.movimientoaceites == 0) {
                me.islamovimientoaceites = 0;
                me.movimientoaceites = 0;
              } else {
                me.islamovimientoaceites = 1;
              }
            }
            if (servicioid == 13) {
              me.movimientoaceitescredito = x.total;
              if (me.movimientoaceitescredito == 0) {
                me.islamovimientoaceitescredito = 0;
                me.movimientoaceitescredito = 0;
              } else {
                me.islamovimientoaceitescredito = 1;
              }
            }
            if (servicioid == 14) {
              me.movimientobienestar = x.total;
              if (me.movimientobienestar == 0) {
                me.islamovimientobienestar = 0;
                me.movimientobienestar = 0;
              } else {
                me.islamovimientobienestar = 1;
              }
            }
            if (servicioid == 15) {
              me.movimientotienda = x.total;
              if (me.movimientotienda == 0) {
                me.islamovimientotienda = 0;
                me.movimientotienda = 0;
              } else {
                me.islamovimientotienda = 1;
              }
            }
            me.movimientototalisla = 0;
            //Efectivo mas dolares
            me.movimientoefectivomasdolares =
              parseFloat(me.movimientoefectivo) +
              parseFloat(me.movimientodolares);
            // Total
            me.movimientototalisla =
              parseFloat(me.movimientoefectivo) +
              parseFloat(me.movimientobancaria) +
              parseFloat(me.movimientocredito) +
              parseFloat(me.movimientoacord) +
              parseFloat(me.movimientoefecticard) +
              parseFloat(me.movimientodolares) +
              parseFloat(me.movimientocupones) +
              parseFloat(me.movimientocheque) +
              parseFloat(me.movimientotransferencia) +
              parseFloat(me.movimientosodexo) +
              parseFloat(me.movimientoultragas) +
              parseFloat(me.movimientoaceites) +
              parseFloat(me.movimientoaceitescredito) +
              parseFloat(me.movimientobienestar);
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    async saldoservisioturno(servicioid) {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get(
          "api/movimientos/saldoservisioturno/" +
          servicioid +
          "/" +
          me.date +
          "/" +
          me.turnoid,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.movimiento;
          listaArray.map(function (x) {
            if (servicioid == 1) {
              me.movimientoefectivoturno = x.total;
              if (me.movimientoefectivoturno == 0) {
                me.totalmovimientoefectivoturno = 0;
              } else {
                me.totalmovimientoefectivoturno = 1;
              }
            }
            if (servicioid == 2) {
              me.movimientobancariaturno = x.total;
              if (me.movimientobancariaturno == 0) {
                me.totalmovimientobancariaturno = 0;
              } else {
                me.totalmovimientobancariaturno = 1;
              }
            }
            if (servicioid == 3) {
              me.movimientocreditoturno = x.total;
              if (me.movimientocreditoturno == 0) {
                me.totalmovimientocreditoturno = 0;
              } else {
                me.totalmovimientocreditoturno = 1;
              }
            }
            if (servicioid == 4) {
              me.movimientoacordturno = x.total;
              if (me.movimientoacordturno == 0) {
                me.totalmovimientoacordturno = 0;
              } else {
                me.totalmovimientoacordturno = 1;
              }
            }
            if (servicioid == 5) {
              me.movimientoefecticardturno = x.total;
              if (me.movimientoefecticardturno == 0) {
                me.totalmovimientoefecticardturno = 0;
              } else {
                me.totalmovimientoefecticardturno = 1;
              }
            }
            if (servicioid == 6) {
              me.movimientodolaresturno = x.total;
              if (me.movimientodolaresturno == 0) {
                me.totalmovimientodolaresturno = 0;
              } else {
                me.totalmovimientodolaresturno = 1;
              }
            }
            if (servicioid == 7) {
              me.movimientocuponesturno = x.total;
              if (me.movimientocuponesturno == 0) {
                me.totalmovimientocuponesturno = 0;
              } else {
                me.totalmovimientocuponesturno = 1;
              }
            }
            if (servicioid == 8) {
              me.movimientochequeturno = x.total;
              if (me.movimientochequeturno == 0) {
                me.totalmovimientochequeturno = 0;
              } else {
                me.totalmovimientochequeturno = 1;
              }
            }
            if (servicioid == 9) {
              me.movimientotransferenciaturno = x.total;
              if (me.movimientotransferenciaturno == 0) {
                me.totalmovimientotransferenciaturno = 0;
              } else {
                me.totalmovimientotransferenciaturno = 1;
              }
            }
            if (servicioid == 10) {
              me.movimientosodexoturno = x.total;
              if (me.movimientosodexoturno == 0) {
                me.totalmovimientosodexoturno = 0;
              } else {
                me.totalmovimientosodexoturno = 1;
              }
            }
            if (servicioid == 11) {
              me.movimientoultragasturno = x.total;
              if (me.movimientoultragasturno == 0) {
                me.totalmovimientoultragasturno = 0;
              } else {
                me.totalmovimientoultragasturno = 1;
              }
            }
            if (servicioid == 12) {
              me.movimientoaceitesturno = x.total;
              if (me.movimientoaceitesturno == 0) {
                me.totalmovimientoaceitesturno = 0;
              } else {
                me.totalmovimientoaceitesturno = 1;
              }
            }
            if (servicioid == 13) {
              me.movimientoaceitescreditoturno = x.total;
              if (me.movimientoaceitescreditoturno == 0) {
                me.totalmovimientoaceitescreditoturno = 0;
              } else {
                me.totalmovimientoaceitescreditoturno = 1;
              }
            }
            if (servicioid == 14) {
              me.movimientobienestarturno = x.total;
              if (me.movimientobienestarturno == 0) {
                me.totalmovimientobienestarturno = 0;
              } else {
                me.totalmovimientobienestarturno = 1;
              }
            }
            if (servicioid == 15) {
              me.movimientotiendaturno = x.total;
              if (me.movimientotiendaturno == 0) {
                me.totalmovimientotiendaturno = 0;
              } else {
                me.totalmovimientotiendaturno = 1;
              }
            }

            me.movimientototalturno = 0;
            me.movimientototalturno =
              parseFloat(me.movimientoefectivoturno) +
              parseFloat(me.movimientobancariaturno) +
              parseFloat(me.movimientocreditoturno) +
              parseFloat(me.movimientoacordturno) +
              parseFloat(me.movimientoefecticardturno) +
              parseFloat(me.movimientodolaresturno) +
              parseFloat(me.movimientocuponesturno) +
              parseFloat(me.movimientochequeturno) +
              parseFloat(me.movimientotransferenciaturno) +
              parseFloat(me.movimientosodexoturno) +
              parseFloat(me.movimientoultragasturno) +
              parseFloat(me.movimientoaceitesturno) +
              parseFloat(me.movimientoaceitescreditoturno) +
              parseFloat(me.movimientobienestarturno);
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    saldoefectivoturno(servicioid) {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientos/saldoservisioturnoefectivodolares/" +
          me.date +
          "/" +
          me.turnoid,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.movimiento;
          listaArray.map(function (x) {
            if (servicioid == 1) {
              me.efectivototal = x.total;
            }
          });
          me.restototal = (
            parseFloat(me.efectivototal) - parseFloat(me.recibototal)
          ).toFixed(2);
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    async servicio() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get(
          "api/movimientos/servicio/" + me.liquidaid + "/" + me.servicioid,
          configuracion
        )
        .then(function (response) {
          me.movimientoselect = response.data.movimiento;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    despachador() {
      this.despachadornombre = event.target.textContent;
    },

    async totaldepachador() {
      if (this.liquidaselect == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }

      if (this.liquidaid == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }
      this.apagar();
      this.modaltotaldespachador = 1;

      await Promise.all([
        this.saldoservicioisla(1),
        this.saldoservicioisla(2),
        this.saldoservicioisla(3),
        this.saldoservicioisla(4),
        this.saldoservicioisla(5),
        this.saldoservicioisla(6),
        this.saldoservicioisla(7),
        this.saldoservicioisla(8),
        this.saldoservicioisla(9),
        this.saldoservicioisla(10),
        this.saldoservicioisla(11),
        this.saldoservicioisla(12),
        this.saldoservicioisla(13),
        this.saldoservicioisla(14),
        this.saldoservicioisla(15),
      ]);

      //this.saldototalisla();
    },

    async totalservisioturno() {
      if (this.turnoselect == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }

      if (this.turnoid == 0) {
        this.$swal("No se a Especificado el Turno");
        return;
      }

      this.apagar();
      this.modaltotalturno = 1;

      await Promise.all([
        this.saldoservisioturno(1),
        this.saldoservisioturno(2),
        this.saldoservisioturno(3),
        this.saldoservisioturno(4),
        this.saldoservisioturno(5),
        this.saldoservisioturno(6),
        this.saldoservisioturno(7),
        this.saldoservisioturno(8),
        this.saldoservisioturno(9),
        this.saldoservisioturno(10),
        this.saldoservisioturno(11),
        this.saldoservisioturno(12),
        this.saldoservisioturno(13),
        this.saldoservisioturno(14),
        this.saldoservisioturno(15),
        this.listarclientes(),
      ]);
    },

    imprimir() {
      window.print();
    },

    whatsappmensaje() {
      let mensaje = "hola";
      return encodeURI(mensaje);
    },

    whatsappweb() {
      return "https://wa.me/526751100973?text=" + this.whatsappmensaje();
    },

    guardar() {
      if (this.despachadornombre == "") {
        this.$swal("No se a Especificado el Despachador");
        return;
      }

      if (this.movimientoimporte == "") {
        this.$swal("No se a Especificado el Importe");
        return;
      }

      if (this.servicioid == 3 && this.clienteigas == "") {
        this.$swal("No se a Especificado Cliente");
        return;
      }

      if (this.servicioid == 3 && this.credito == "") {
        this.$swal("No se a Especificado Credito");
        return;
      }

      this.verguardarservicio = 0;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      //Editar
      let me = this;
      axios
        .post(
          "api/movimientos/crear",
          {
            liquidacionid: me.liquidaid,
            servicioid: me.servicioid,
            movimientoimporte: me.movimientoimporte,
            movimientoobservacion: me.movimientoobservacion,
            movimientofecha: me.date,
            turnoid: me.turnoid,
            clienteigas: me.clienteigas,
            credito: me.credito,
            restobilleteefectivo: me.restobilleteefectivo,
            creditoticket: me.creditoticket,
            combustibleid: me.combustibleid,
            creditolitros: me.creditolitros,
            creditounidad: me.creditounidad,
            creditoautorizaocarga: me.creditoautorizaocarga,
            creditovale: me.creditovale,
            movimientovalor: me.movimientodolares,
            movimientoparametrovalor: me.movimientovalordolares,
            sucursalid: me.sucursalid,
            departamentoid: me.departamentoid,
          },
          configuracion
        )
        .then(function (response) {
          var totalmovimiento = new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(me.movimientoimporte);
          me.$swal(me.servicionombre + " Capturado con Exito " + totalmovimiento).then((result) => {

            me.$refs.focoimporte.focus();


          });
          me.limpiarvale();
          me.saldoservicio();
          me.servicio();
          me.verguardarservicio = 1;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardarrecibo() {
      if (this.reciboid == "") {
        this.$swal("No se a Especificado el Tipo del Recibo");
        return;
      }

      if (this.recibofolio == "") {
        this.$swal("No se a Especificado el Folio del Recibo");
        return;
      }

      if (this.reciboimporte == "") {
        this.$swal("No se a Especificado el Importe del Recibo");
        return;
      }

      if (this.reciboconcepto == "") {
        this.$swal("No se a Especificado el Concepto");
        return;
      }

      if (this.reciboentrega == "") {
        this.$swal("No se a Especificado quien Recibe");
        return;
      }

      if (this.autorizanombre == "") {
        this.$swal("No se a Especificado quien Autorizo");
        return;
      }

      if (this.reciboentrega == "") {
        this.$swal("No se a Especificado quien Entrega");
        return;
      }

      this.verguardarrecibo = 0;

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      //Editar
      let me = this;
      axios
        .post(
          "api/recibos/crear",
          {
            recibofecha: me.date,
            recibotipo: me.reciboid,
            reciboimporte: me.reciboimporte,
            reciboconcepto: me.reciboconcepto,
            recibofolio: me.recibofolio,
            reciboautorizo: "Carlitos",
            reciborecibe: me.reciborecibe,
            usuarioid: me.$store.state.usuario.usuarioid,
            turnoid: me.turnoid,
            reciboentrega: me.reciboentrega,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiarrecibos();
          me.recibosturno();
          me.saldorecibo();
          me.saldoefectivoturno(1);
          me.$swal("Recibo Generado con Exito");
          me.verguardarrecibo = 1;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardarcreditodetalle() {
      if (this.movimientoimporte == "") {
        this.$swal("No se a Capturado el Importe del Ticket");
        return;
      }

      if (this.combustibleid == "") {
        this.$swal("No se a Capturado el Tipo de Combustible");
        return;
      }




      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      //Editar
      let me = this;
      axios
        .post(
          "api/creditodetalles/crear",
          {
            movimientoid: me.movimientoid,
            liquidacionid: me.liquidacionid,
            creditoimporte: me.movimientoimporte,
            creditofecha: me.date,
            creditovale: me.credito,
            creditoticket: me.creditoticket,
            combustibleid: me.combustibleid,
            creditolitros: me.creditolitros,
            creditounidad: me.creditounidad,
            creditoautorizaocarga: me.creditoautorizaocarga,
            clienteid: me.clienteigas,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiarcreditodetalle();
          me.$swal("Credito Detalle Generado con Exito");
          me.listarcreditodetalle();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listarcreditodetalle() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get(
          "api/creditodetalles/listar/" +
          me.movimientoid +
          "/" +
          me.liquidacionid +
          "/" +
          me.date,
          configuracion
        )
        .then(function (response) {
          me.creditodetalle = response.data.creditodetalle;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.contrasenia1) {
        this.validamensaje.push("La Nueva Contraseña esta Vacia");
      }

      if (!this.contrasenia2) {
        this.validamensaje.push("La Confirmacion Nueva Contraseña esta Vacia");
      }

      if (this.contrasenia1 != this.contrasenia2) {
        this.validamensaje.push("Las Contraseñas no son Iguales");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    close() {
      this.modalservicio = 0;
      this.modaltotaldespachador = 0;
      this.modaltotalturno = 0;
      this.movimientoimporte = "";
      this.modalrecibo = "";
      this.modaleditarecibo = 0;
      this.modaleditaservicio = 0;
      this.modalreclasificacion = 0;
      this.modelbilletesresto = 0;
    },

    closerecto() {
      this.modalrestoturno = 0;
      this.modelbilletesresto = 0;
      this.modelcreditodetalle = 0;
    },
  },
};
</script>

<style>
#interactive.viewport {
  position: relative;
}

#espacio {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px;
}

#interactive.viewport>canvas,
#interactive.viewport>video {
  max-width: 100%;
  width: 100%;
}
</style>
